import Vue from 'vue';
import Vuex from 'vuex';

/*----------  Modules  ----------*/
import feedback from './modules/feedback';
// import settings from './modules/settings';
import loading from './modules/loading';
import auth from './modules/auth';
import settings from './modules/settings';
import authenticators from './modules/authenticators';
import secretTemplates from './modules/secrettemplates';

Vue.use(Vuex);

const state = {};

const getters = {};

const actions = {
  asyncData() {
    return Promise.all([
      this.dispatch('loading/setLoading', true),
      this.dispatch("authenticators/getAuthenticators"),
    ]).then(() => {
      this.dispatch('loading/setLoading', false);
    });
  }
};

const mutations = {
  initialiseStore(state) {
    // Check if the ID exists
    if (localStorage.getItem('store')) {
      this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem('store')))
      );
    }
  }
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    feedback,
    loading,
    auth,
    settings,
    authenticators,
    secretTemplates,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js